import { http } from "./config";
import authHeader from "./auth-header";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

let stompClient = null;
let subscription = null;

export default {
  listarProtocolos(params) {
    return http.get("/wazzup-chat/protocolos", {
      params,
      headers: authHeader(),
    });
  },

  listarProtocoloPorId(id) {
    return http.get(`/wazzup-chat/protocolos/${id}`, {
      headers: authHeader(),
    });
  },

  listarMensagens(idProtocolo) {
    return http.get(
      `/wazzup-chat/protocolos/${idProtocolo}/mensagens`,
      {
        headers: authHeader(),
      },
    );
  },
  getProtocolsByPhone(telefone, empresa) {
    return http.get(`/wazzup-chat/protocolos/by-phone`, {
      params: {
        telefone: telefone,
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  aceitarAtendimento(idProtocolo) {
    return http.post(
      `/wazzup-chat/protocolos/${idProtocolo}/aceitar-atendimento`,
      null,
      {
        headers: authHeader(),
      },
    );
  },

  transferirAtendimento(idProtocolo, idNovoAtendente) {
    return http.post(
      `/wazzup-chat/protocolos/${idProtocolo}/transferir-atendimento`,
      null,
      {
        params: { idNovoAtendente },
        headers: authHeader(),
      },
    );
  },

  sairAtendimento(idProtocolo) {
    return http.post(
      `/wazzup-chat/protocolos/${idProtocolo}/sair-atendimento`,
      null,
      {
        headers: authHeader(),
      },
    );
  },

  finalizarProtocolo(idProtocolo) {
    return http.post(
      `/wazzup-chat/protocolos/${idProtocolo}/finalizar`,
      null,
      {
        headers: authHeader(),
      },
    );
  },

  adicionarParticipante(idProtocolo, idParticipante) {
    return http.post(
      `/wazzup-chat/protocolos/${idProtocolo}/participante`,
      null,
      {
        params: { idParticipante },
        headers: authHeader(),
      },
    );
  },

  removerParticipante(idProtocolo) {
    return http.delete(`/wazzup-chat/protocolos/${idProtocolo}/participante`, {
      headers: authHeader(),
    });
  },

  transferirFila(protocolNumber, idFila) {
    return http.post(
      `/wazzup-chat/protocolos/${protocolNumber}/alterar-fila`,
      {},
      {
        params: {
          idFila: idFila,
        },
        headers: authHeader(),
      },
    );
  },

  iniciarAtendimento(dto) {
    return http.post("/wazzup-chat/iniciar-atendimento", dto, {
      headers: authHeader(),
    });
  },

  enviarMensagem(dto) {
    return http.post("/wazzup-chat/enviar-mensagem", dto, {
      headers: authHeader(),
    });
  },
  enviarArquivo({ channelId, telefone, protocolo, file, fileUrl, isAudio = false }) {
    const formData = new FormData();
    formData.append("channelId", channelId);
    formData.append("telefone", telefone);
    formData.append("protocolo", protocolo);
    
    // Adicionar file ou fileUrl dependendo do que foi fornecido
    if (file) {
      formData.append("file", file);
    }
    if (fileUrl) {
      formData.append("fileUrl", fileUrl);
    }
    
    formData.append("isAudio", isAudio);

    return http.post("/wazzup-chat/enviar-arquivo", formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Templates CRUD
  listarTemplates(empresa) {
    const params = empresa ? { empresa } : {};
    return http.get("/wazzup-chat/templates", {
      params,
      headers: authHeader(),
    });
  },

  obterTemplatePorId(id) {
    return http.get(`/wazzup-chat/templates/${id}`, {
      headers: authHeader(),
    });
  },

  criarTemplate(template) {
    return http.post("/wazzup-chat/templates", template, {
      headers: authHeader(),
    });
  },

  atualizarTemplate(id, template) {
    return http.post(`/wazzup-chat/templates/${id}`, template, {
      headers: authHeader(),
    });
  },

  deletarTemplate(id) {
    return http.delete(`/wazzup-chat/templates/${id}`, {
      headers: authHeader(),
    });
  },

  // URA CRUD
  listarUras(empresa) {
    const params = empresa ? { empresa } : {};
    return http.get("/wazzup-chat/uras", {
      params,
      headers: authHeader(),
    });
  },

  obterUraPorId(id) {
    return http.get(`/wazzup-chat/uras/${id}`, {
      headers: authHeader(),
    });
  },

  criarUra(ura) {
    return http.post("/wazzup-chat/uras", ura, {
      headers: authHeader(),
    });
  },

  atualizarUra(id, ura) {
    return http.post(`/wazzup-chat/uras/${id}`, ura, {
      headers: authHeader(),
    });
  },

  deletarUra(id) {
    return http.delete(`/wazzup-chat/uras/${id}`, {
      headers: authHeader(),
    });
  },

  /* ===========================
   * WEBSOCKET
   * =========================== */

  connectWebSocket(callbacks = {}) {
    if (stompClient && stompClient.connected) {
      return stompClient;
    }

    const wsUrl = `${http.defaults.baseURL.replace(/\/$/, "")}/ws`;

    const socket = new SockJS(wsUrl);
    stompClient = Stomp.over(socket);

    stompClient.debug = (msg) => {
    };

    stompClient.connect(
      authHeader() || {},
      (frame) => {
        callbacks.onConnect?.(frame);
      },
      (error) => {
        callbacks.onError?.(error);
      },
    );

    return stompClient;
  },

  subscribeProtocoloAtualizado(callback) {
    if (!stompClient || !stompClient.connected) {
      return null;
    }

    if (subscription) {
      return subscription;
    }


    subscription = stompClient.subscribe(
      "/topic/protocolos",
      (message) => {
        const protocoloId = Number(message.body);
        callback?.(protocoloId);
      },
    );

    return subscription;
  },

  disconnect() {
    if (subscription) {
      subscription.unsubscribe();
      subscription = null;
    }

    if (stompClient) {
      stompClient.disconnect(() => {
        stompClient = null;
      });
    }
  },
};
